import React from 'react';
import { faPeopleGroup} from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const FamilyIcon = ({toolTipText = 'Manage Family'}) => (
  <Icon tooltip={toolTipText} iconObj={faPeopleGroup} />
);

export default FamilyIcon;